// extracted by mini-css-extract-plugin
export default {"container":"InlineClient--container--a31d95","message":"InlineClient--message--8806a8","gdprMessage":"InlineClient--gdprMessage--d54656","checkbox":"InlineClient--checkbox--c90c9f"};